export const convertColorToARGB = (color) => {
    // new color from MuiColorInput: 'rgba(255, 0, 0, 1)' || 'rgb(255, 0, 0)'
    // output: {A: 1, R: 255, G: 0, B: 0} A: 0-1, R: 0-255, G: 0-255, B: 0-255
    // if rgba -> A: value of alpha channel (0-1). If rgb -> A: 1
    const colorArray = color.split('(')[1].split(')')[0].split(',');
    const alpha = colorArray.length === 4 ? parseFloat(colorArray[3]) : 1;
    return {
        A: alpha,
        R: parseInt(colorArray[0]),
        G: parseInt(colorArray[1]),
        B: parseInt(colorArray[2])
    };
};
export const convertColorToRGBA = (color) => {
    return `rgba(${color.R}, ${color.G}, ${color.B}, ${color.A})`;
};

